export default __webpack_public_path__ + "static/media/CL12.1.bfa64ab6.mp3";